await themeComponent(theme.components['mc-element'], false);

class McConverter extends McElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // robust number extraction: handles 12 345,67 / €1,234.50 / newlines, etc.
    const raw = this.textContent || '';
    const numMatch = raw.replace(/\u00A0|\u202F|\u2007/g, ' ')   // NBSP/thin/figure spaces → space
                        .match(/[-+]?\d+(?:[.,]\d+)?/);          // first numeric token

    const factorRaw = this.dataset.factor ?? '1';
    const factorMatch = String(factorRaw).match(/[-+]?\d+(?:[.,]\d+)?/);

    const original = numMatch ? parseFloat(numMatch[0].replace(',', '.')) : NaN;
    const factor   = factorMatch ? parseFloat(factorMatch[0].replace(',', '.')) : 1;

    this.originalValue  = original;
    this.convertedValue = original * factor;

    if (this.dataset.round !== undefined) {
      // only round if both numbers are valid
      if (!Number.isNaN(this.originalValue))  this.originalValue  = Math.round(this.originalValue);
      if (!Number.isNaN(this.convertedValue)) this.convertedValue = Math.round(this.convertedValue);
    }
  }

  afterOpen = () => {
    this.innerHTML = Number.isNaN(this.convertedValue) ? '' : String(this.convertedValue);
  }

  afterClose = () => {
    this.innerHTML = Number.isNaN(this.originalValue) ? '' : String(this.originalValue);
  }
}

if (!window.customElements.get('mc-converter')) {
  window.customElements.define('mc-converter', McConverter);
}
window.McConverter = McConverter;
